var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Partners"},[_c('div',{staticClass:"Partners-Title"},[_vm._v(" "+_vm._s(_vm.partnersTitle)+" ")]),_c('PartnersSlider',{attrs:{"slider-info":_vm.sliderInfo}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }